import {
  Timeseries,
  TimeseriesDatapoint,
} from '../../core/types/timeseries.js';

/**
 * Detects if there are any misaligned data points in the timeseries.
 * Returns true if there's any misaligned point, false otherwise
 *
 * @param timeseries -
 */
export const detectMisalignedDatapoints = (timeseries: Timeseries[]) => {
  if (timeseries.length < 2) {
    return false;
  }
  if (seriesAreJagged(timeseries)) {
    return true;
  }

  return !seriesDatapointsAreAligned(timeseries);
};

/**
 * Returns true if the series collection is jagged, meaning that the
 * amount of data points of each series is different.
 *
 * @param timeseries -
 */
export const seriesAreJagged = (timeseries: Timeseries[]): boolean => {
  let isJagged = false;
  let i = 1;
  const { length } = timeseries[0].datapoints;
  while (!isJagged && i < timeseries.length) {
    isJagged = length !== timeseries[i].datapoints.length;
    i++;
  }

  return isJagged;
};

/**
 * Check if every data point of each series is aligned.
 * It assumes there is an equal amount of data points in each series
 * of the collection.
 *
 * @param timeseries -
 */
const seriesDatapointsAreAligned = (timeseries: Timeseries[]): boolean => {
  let dpAreAligned = true;

  const firstSeriesDatapoints = timeseries[0].datapoints;
  const datapointsLength = firstSeriesDatapoints.length;
  const seriesLength = timeseries.length;
  let i = 0;
  while (dpAreAligned && i < datapointsLength) {
    let j = 1;
    const dp1 = firstSeriesDatapoints[i];
    while (dpAreAligned && j < seriesLength) {
      const dp2 = timeseries[j].datapoints[i];
      dpAreAligned = datapointsAreAligned(dp1, dp2);
      j++;
    }
    i++;
  }

  return dpAreAligned;
};

const datapointsAreAligned = (
  dp1: TimeseriesDatapoint,
  dp2: TimeseriesDatapoint,
): boolean => {
  const marker1 = dp1.end ? dp1.end : dp1.start;
  const marker2 = dp2.end ? dp2.end : dp2.start;

  return marker1.getTime() === marker2.getTime();
};
